{
  "status": {
    "DRAFT": "Draft",
    "PENDING_APPROVAL": "Awaiting approval",
    "SUBMITTED": "Submitted",
    "CERTIFIED": "Certified",
    "REJECTED": "Rejected",
    "VOID": "Void"
  },
  "kind": {
    "INTERIM": "Interim",
    "FINAL": "Final"
  },
  "stage": {
    "COMPLETION": "At completion",
    "DLP_END": "End of defects liability period",
    "OTHER": "Other"
  },
  "actions": {
    "new": "New claim",
    "submit": "Submit",
    "certify": "Record certification",
    "reject": "Record rejection",
    "void": "Void",
    "delete": "Delete draft",
    "sendForApproval": "Send for approval",
    "reviewApproval": "Review",
    "approveInternal": "Approve",
    "returnInternal": "Return to draft"
  },
  "register": {
    "title": "Progress claims",
    "position": "Certified to date {{certified}} of a contract value of {{value}} ({{pct}}).",
    "claim": "Claim",
    "retention": "Retention",
    "recovery": "Advance recovery",
    "penalty": "Delay damages",
    "net": "Net",
    "invoice": "Invoice",
    "status": "Status",
    "actions": "Actions",
    "draftName": "Draft claim",
    "emptyTitle": "No progress claims yet",
    "empty": "Start the first progress claim from the BOQ.",
    "openClaim": "{{number}} is still open: submit, certify, reject or delete it first.",
    "voidNamed": "Void {{number}}",
    "vatLine": "VAT {{amount}}",
    "kindPeriod": "{{kind}} · to {{date}}",
    "gross": "Gross",
    "groupToDate": "To date",
    "groupCertificate": "This certificate"
  },
  "newClaim": {
    "title": "New progress claim",
    "description": "The draft copies every line of the current BOQ, with what was certified before.",
    "kind": "Kind",
    "interimHint": "A monthly claim against work done to date.",
    "finalHint": "The last claim: it recovers the whole advance.",
    "periodTo": "Period to",
    "periodToHint": "The last day of work this claim measures.",
    "confirm": "Start claim",
    "done": "Draft claim started"
  },
  "submit": {
    "title": "Submit this claim?",
    "body": "This takes the next IPC number and freezes the applied figures: a net of {{net}} before VAT goes to the client for certification.",
    "bodyFinal": "This takes the next IPC number and freezes the applied figures of the final claim: a net of {{net}} before VAT, recovering the whole advance.",
    "confirm": "Submit claim",
    "done": "Submitted as {{number}}",
    "approvalTitle": "Send the claim for approval?",
    "approvalBody": "It waits for internal approval, applying for a net of {{net}}. The final approval numbers it and submits it to the client.",
    "approvalConfirm": "Send for approval",
    "sentForApproval": "Claim sent for internal approval"
  },
  "reject": {
    "title": "Record rejection of {{number}}",
    "body": "The client did not certify {{number}}. Its number stays used; the next claim measures again from the last certificate.",
    "reason": "Client’s reason",
    "clientRef": "Client’s reference",
    "confirm": "Record rejection",
    "done": "{{number}} rejected"
  },
  "void": {
    "title": "Void {{number}}",
    "titlePlain": "Void claim",
    "body": "This voids invoice {{invoice}} ({{total}}) to {{customer}} and reverses the certificate journal. {{number}} stays used; the next claim measures again from the one before.",
    "blockedTitle": "This claim can’t be voided now",
    "reason": "Reason",
    "confirm": "Void claim",
    "done": "{{number}} voided"
  },
  "delete": {
    "title": "Delete this draft claim?",
    "body": "The draft has no number yet; its measurements go with it.",
    "confirm": "Delete draft",
    "done": "Draft claim deleted"
  },
  "editor": {
    "title": "Progress claim",
    "back": "Back to the claims",
    "backTo": "{{code}} claims",
    "ariaTitle": "{{number}} of {{code}}",
    "periodTo": "Period to {{date}}",
    "invoice": "Invoice {{number}}",
    "noContract": "This project has no contract",
    "noContractBody": "Claims measure an active contract’s BOQ. Set up the contract on the Contract tab first.",
    "save": "Save draft",
    "saveCertified": "Save certified figures",
    "saved": "Claim saved",
    "saveFailed": "The claim wasn’t saved",
    "noChanges": "Nothing changed since the last save.",
    "fixRefused_one": "Correct the line the contract refuses first.",
    "fixRefused_other": "Correct the {{count}} lines the contract refuses first.",
    "refusedTitle_one": "1 line can’t be claimed as measured",
    "refusedTitle_other": "{{count}} lines can’t be claimed as measured",
    "refusedBody": "A percentage goes up to 100% and a figure can’t be negative. Correct the marked lines to save.",
    "refusedBodyBlock": "This contract refuses measuring above an item’s quantity (and percentages above 100%). Correct the marked lines, or record a variation for the extra work.",
    "warnedTitle_one": "1 line is measured above its quantity",
    "warnedTitle_other": "{{count}} lines are measured above their quantity",
    "warnedBody": "The contract allows it with a warning. If the client agreed extra quantities, a variation keeps the BOQ true.",
    "certifiedModeTitle": "Enter the client’s certified figures",
    "certifiedModeBody": "They start as applied. Change a figure where the client certified less or more; set a value or a deduction to the baisa with a reason when their certificate differs.",
    "rejectedTitle": "The client rejected this claim",
    "voidTitle": "This claim was voided",
    "sheet": "Measurement",
    "sheetCertified": "Certified measurement",
    "keys": "Arrow keys move between figures · Enter confirms · Esc puts it back",
    "noLines": "The current BOQ has no lines to measure.",
    "details": "Claim details",
    "kind": "Kind",
    "periodToLabel": "Period to",
    "penalty": "Delay damages to date",
    "penaltyHint": "Agreed damages for late completion, cumulative; they reduce the value before VAT.",
    "manualRecovery": "Advance recovered to date",
    "manualRecoveryHint": "This contract recovers the advance by agreement; capped at the advance.",
    "notes": "Notes",
    "phoneTitle": "Open on a computer to edit claims",
    "phoneBody": "Measuring a claim needs the full sheet. Here are its figures.",
    "phoneLines_one": "1 line measured to date.",
    "phoneLines_other": "{{count}} lines measured to date.",
    "stuckFinalTitle": "This final certificate would be negative",
    "stuckFinalBody": "The advance still to recover ({{recovery}}) is more than this certificate’s gross ({{gross}}). Reduce the advance by a credit note on the advance invoice, then certify.",
    "stuckFinalAction": "Reduce advance…",
    "stuckFinalAsk": "Someone who may bill the project can reduce it."
  },
  "grid": {
    "label": "Claim measurement",
    "item": "Item",
    "description": "Description",
    "unit": "Unit",
    "quantity": "Contract qty",
    "previous": "Previous",
    "applied": "Applied",
    "period": "This period",
    "cumulative": "Cumulative",
    "certifiedCumulative": "Certified cumulative",
    "rate": "Rate",
    "value": "Value to date",
    "byPercent": "by %",
    "cellLabel": "{{column}}, item {{item}}",
    "overrideNamed": "Set the client’s value of item {{item}}",
    "overrideReason": "Client’s value: {{reason}}",
    "clientFigure": "client’s figure",
    "issue": {
      "OVER_MEASURE": "Above the contract quantity ({{quantity}}): the contract refuses it.",
      "OVER_MEASUREWarn": "Above the contract quantity ({{quantity}}).",
      "PERCENT_OVER_100": "Above 100%.",
      "NEGATIVE": "Below zero."
    }
  },
  "tape": {
    "label": "Certificate",
    "gross": "Gross to date",
    "previous": "Previously certified",
    "period": "This period",
    "retention": "Retention {{rate}}",
    "recovery": "Advance recovery",
    "penalty": "Delay damages",
    "net": "Net",
    "vat": "VAT {{rate}}",
    "total": "Total due",
    "toDate": "to date {{amount}}",
    "clientFigure": "client’s figure",
    "overrideNamed": "Set the client’s figure for {{label}}",
    "errors": {
      "NEGATIVE_CERTIFICATE": "The net of this certificate is not above zero: deductions exceed the work of the period. Measure more work, or leave the deductions to the next claim.",
      "RETENTION_BELOW_RELEASED": "Retention to date would fall below what was already released. Check the retention figure.",
      "RECOVERY_ABOVE_ADVANCE": "The advance recovery would exceed the advance invoiced. Check the recovery figure.",
      "RETENTION_ABOVE_GROSS": "Retention to date would exceed the gross certified to date. Check the retention figure."
    },
    "op": {
      "less": "less",
      "equals": "equals",
      "plus": "plus"
    }
  },
  "override": {
    "lineTitle": "Client’s value of item {{item}}",
    "lineBody": "The value to date as the client certified it, to the baisa.",
    "retentionTitle": "Client’s retention to date",
    "recoveryTitle": "Client’s advance recovery to date",
    "deductionBody": "The contract terms give {{amount}} to date. Enter the client’s figure when their certificate differs.",
    "computed": "Calculated: {{amount}}",
    "amount": "Amount to date",
    "reason": "Reason",
    "reasonRequired": "Say why the figure differs.",
    "confirm": "Use this figure",
    "clear": "Use the calculated figure"
  },
  "certify": {
    "title": "Record certification of {{number}}",
    "description": "The client’s certificate: their reference and date. Certifying issues the tax invoice.",
    "clientRef": "Client’s certificate reference",
    "clientRefHint": "As on their certificate or letter.",
    "clientRefRequired": "Enter the client’s reference.",
    "certifiedOn": "Certified on",
    "certifiedOnHint": "The invoice is dated this day.",
    "consequence": "This issues an invoice to {{customer}} for {{total}} (VAT {{vat}}), due {{due}}, posts the certificate journal and locks {{number}}.",
    "refused": "This certificate can’t be recorded",
    "previewFailed": "The preview couldn’t be prepared",
    "slip": "What certifying creates",
    "previewStamp": "Preview",
    "meta": "Dated {{date}} · due {{due}}",
    "net": "Net",
    "vat": "VAT",
    "total": "Total",
    "journal": "Certificate journal",
    "account": "Account",
    "debit": "Debit",
    "credit": "Credit",
    "posts": "The invoice is posted at once.",
    "confirm": "Record certification",
    "retry": "Try again",
    "failed": "The certification wasn’t recorded",
    "toast": "{{number}} certified: invoice {{invoice}} issued",
    "doneTitle": "{{number}} certified",
    "doneBody": "{{number}} is certified and invoice {{invoice}} for {{total}} is issued and posted.",
    "openInvoice": "Open {{number}}",
    "close": "Done"
  },
  "retention": {
    "title": "Retention",
    "hint": "Held from each certificate until completion and the end of the defects period; released by invoice, stage by stage.",
    "strip": "Retention figures",
    "held": "Held",
    "released": "Released",
    "balance": "Balance",
    "stages": "Release stages",
    "stage": "Stage",
    "share": "Share",
    "dueOn": "Due on",
    "proposed": "To release",
    "releasedCol": "Released",
    "stageName": "Stage {{n}} · {{stage}}",
    "onRequest": "When agreed",
    "dueStamp": "Due",
    "releaseStage": "Release stage {{n}}",
    "releaseEarly": "Release stage {{n}} early",
    "byCertificate": "Held by certificate",
    "noCertificates": "Nothing held yet: retention starts with the first certificate.",
    "certifiedOn": "Certified on",
    "period": "This certificate",
    "toDate": "To date",
    "releases": "Releases",
    "noReleases": "No retention released yet.",
    "date": "Date",
    "amount": "Amount",
    "voidNamed": "Void release {{number}}",
    "pendingTitle": "Retention will grow",
    "pending": "{{number}} is open: stage {{n}} becomes {{amount}} once it is certified."
  },
  "release": {
    "title": "Release retention: {{stage}}",
    "dueBody": "The stage is due. Releasing invoices the amount with VAT at the contract’s rate.",
    "earlyBody": "The stage is not due yet: say why it is released early.",
    "amountHint": "Balance held: {{balance}}",
    "reason": "Reason for releasing early",
    "reasonRequired": "Say why it is released before it is due.",
    "confirm": "Release and invoice",
    "done": "Retention released: {{amount}} invoiced",
    "line": "Release of retention (stage {{n}}) — {{code}}",
    "voidTitle": "Void release {{number}}",
    "voidBody": "This voids the release invoice of {{amount}}: the amount is held again.",
    "voidConfirm": "Void release",
    "voided": "Release voided"
  },
  "advance": {
    "title": "Advance payment",
    "hint": "Invoiced at the start and recovered from each certificate; VAT is charged on the advance invoice.",
    "strip": "Advance figures",
    "invoiced": "Invoiced (net)",
    "recovered": "Recovered",
    "outstanding": "Outstanding",
    "none": "No advance invoiced.",
    "noneProposed": "No advance invoiced. The contract proposes {{amount}} before VAT.",
    "issue": "Issue advance invoice",
    "issueTitle": "Issue advance invoice",
    "issueBody": "One advance per contract. Certificates recover it as the contract says.",
    "byPercent": "Percentage",
    "byPercentHint": "Of the original contract sum.",
    "byAmount": "Amount",
    "byAmountHint": "An agreed figure, before VAT.",
    "percent": "Advance %",
    "percentHint": "Of {{amount}}",
    "amount": "Amount before VAT",
    "confirm": "Issue and post",
    "done": "Advance invoice issued for {{amount}}",
    "line": "Advance payment {{pct}} — {{code}}",
    "reducible": "Its guarantee is reducible to {{amount}}.",
    "recoveries": "Recovered by certificate",
    "noRecoveries": "No certificate has recovered any of it yet.",
    "recoveredCol": "Recovered",
    "void": "Void advance invoice",
    "voidTitle": "Void advance invoice {{number}}",
    "voidBody": "This voids {{number}} ({{total}}). Only possible before any certificate recovers it.",
    "voidConfirm": "Void advance",
    "voided": "{{number}} voided"
  },
  "money": {
    "invoiceDate": "Invoice date",
    "vatAt": "VAT {{rate}}",
    "due": "Due",
    "amountRequired": "Enter an amount above zero.",
    "consequence": "This issues an invoice to {{customer}} for {{total}} (VAT {{vat}}), due {{due}}.",
    "journal": "Journal"
  },
  "print": {
    "application": "Payment application",
    "certificate": "Payment certificate",
    "which": "Document",
    "back": "Back to {{number}}"
  },
  "printDoc": {
    "certificate": "Interim payment certificate",
    "finalCertificate": "Final payment certificate",
    "application": "Application for payment",
    "measurement": "Measurement",
    "breakdown": "Certificate breakdown",
    "periodTo": "Period to",
    "submittedOn": "Submitted",
    "certifiedOn": "Certified",
    "clientRef": "Client ref.",
    "contractNo": "Contract no.",
    "invoice": "Tax invoice",
    "client": "Client",
    "clientReference": "Reference",
    "project": "Project",
    "originalSum": "Original contract sum",
    "variations": "Approved variations",
    "currentValue": "Current contract value",
    "item": "Item",
    "toDate": "To date",
    "previous": "Previous",
    "thisPeriod": "This period",
    "gross": "Gross value of work done",
    "retention": "Retention",
    "recovery": "Advance recovery",
    "penalty": "Delay damages",
    "net": "Net value",
    "less": "Less",
    "vat": "VAT {{rate}} on this period",
    "amountDue": "Amount due this certificate",
    "amountApplied": "Amount applied for",
    "invoiceLine": "Tax invoice {{number}} dated {{date}}.",
    "signatures": "Signatures",
    "preparedBy": "Prepared by (contractor)",
    "certifiedBy": "Certified by (engineer)",
    "approvedBy": "Approved by (client)",
    "submittedBy": "Submitted by (contractor)",
    "receivedBy": "Received by (client)",
    "companyStamp": "Company stamp",
    "nameDate": "Name and date",
    "fixedLine": "Amounts in Omani rials (<rial/>)."
  },
  "reconciliation": {
    "title": "Contract reconciliation",
    "meta": "The contracting accounts in the ledger against Projects’ own figures. Every difference should be zero.",
    "asOf": "As of",
    "table": "Reconciliation",
    "identityCol": "Account",
    "ledger": "Ledger",
    "projects": "Projects",
    "difference": "Difference",
    "other": "Other postings",
    "otherHint": "From outside Projects (e.g. manual journals)",
    "notZero": "not zero",
    "reconciled": "Reconciled",
    "differs": "Difference",
    "allZero": "Every contracting account agrees with Projects at {{date}}.",
    "someDiffer_one": "1 account differs at {{date}}: {{list}}. Open it to see the projects behind it.",
    "someDiffer_other": "{{count}} accounts differ at {{date}}: {{list}}. Open them to see the projects behind them.",
    "toggle_one": "{{identity}}: show 1 project",
    "toggle_other": "{{identity}}: show {{count}} projects",
    "footnote": "Balances at the end of {{date}}. Projects’ figures come from certified claims, advance invoices and retention releases.",
    "identity": {
      "ADVANCES": "Customer advances",
      "RETENTION": "Retention receivable",
      "REVENUE": "Contract revenue"
    },
    "explain": {
      "ADVANCES": "Advance invoices (net) less what certificates recovered",
      "RETENTION": "Retention certified less releases",
      "REVENUE": "Certified gross less delay damages"
    },
    "someDifferOther_one": "1 account differs at {{date}}: {{list}}. It comes from postings outside Projects (Other postings).",
    "someDifferOther_other": "{{count}} accounts differ at {{date}}: {{list}}. They come from postings outside Projects (Other postings).",
    "otherLink": "Other postings to {{identity}} in the General ledger"
  },
  "blocked": {
    "NOT_PERMITTED": "You don’t have permission for this.",
    "ILLEGAL_MOVE": "Not possible in this claim’s state.",
    "NEGATIVE_CERTIFICATE": "The net of this certificate is not above zero.",
    "RETENTION_BELOW_RELEASED": "Retention to date would fall below what was released.",
    "CLAIM_NOT_LATEST": "Only the latest certified claim can be voided; a later one corrects this one.",
    "CLAIM_HAS_LATER": "A later claim is open: delete or reject it first.",
    "RETENTION_RELEASED": "Retention was released against it: voiding would leave less held than released. Void the release first.",
    "INVOICE_HAS_PAYMENTS": "Receipts are applied to its invoice: remove them in Sales first.",
    "SALES_MODULE_OFF": "Sales is turned off for your company, so no invoice can change.",
    "FEATURE_OFF": "Progress claims are turned off for this project.",
    "RECOVERY_ABOVE_ADVANCE": "The recovery would exceed the advance invoiced.",
    "RETENTION_ABOVE_GROSS": "Retention would exceed the gross certified."
  },
  "errors": {
    "FEATURE_REQUIRES": "Turn on the functions this one needs first (Settings › Projects).",
    "CONTRACT_ACTIVE": "The contract is already active.",
    "CONTRACT_NOT_ACTIVE": "Activate the contract first: claims measure its BOQ.",
    "BOQ_REQUIRED": "Choose a BOQ version for the contract.",
    "CUSTOMER_REQUIRED": "The project needs a customer.",
    "BOQ_FROZEN": "This BOQ version can no longer change.",
    "IMPORT_STALE": "The BOQ changed since the preview: preview the import again.",
    "VARIATION_FROZEN": "Only a draft variation can change.",
    "BELOW_CERTIFIED": "The quantity would fall below what is already certified.",
    "CLAIM_OPEN": "Another claim is still open: submit, certify, reject or delete it first.",
    "FINAL_CERTIFIED": "The final claim is certified: no more claims on this contract.",
    "CLAIM_NOT_SUBMITTED": "The claim is no longer submitted: reload it.",
    "OVER_MEASURE": "A line is measured above its quantity, which this contract refuses.",
    "PERCENT_OVER_100": "A line is measured above 100%.",
    "OVERRIDE_REASON_REQUIRED": "Give a reason for each figure that differs from the calculation.",
    "NEGATIVE_CERTIFICATE": "The net of this certificate is not above zero.",
    "RETENTION_BELOW_RELEASED": "Retention to date would fall below what was released.",
    "CLAIM_NOT_LATEST": "Only the latest certified claim can be voided.",
    "CLAIM_HAS_LATER": "A later claim is open: delete or reject it first.",
    "RETENTION_RELEASED": "Retention was released against it: void the release first.",
    "ADVANCE_EXISTS": "This contract already has an advance invoice.",
    "ADVANCE_RECOVERED": "Certificates have recovered part of the advance, so its invoice can no longer be voided.",
    "RETENTION_EXCEEDS_HELD": "That is more than the retention still held.",
    "BILLING_BY_CLAIMS": "This project bills its contract through claims, the advance and retention releases.",
    "GL_ROLE_LINES": "A contract invoice has one line issued by the project.",
    "CONTROL_ACCOUNT": "That account is a control account: only its documents post to it.",
    "ROLE_ACCOUNT_SHARED": "Each contracting role needs its own account: review the account mapping.",
    "VERSION_CONFLICT": "Someone changed this claim meanwhile: reload it and enter your changes again.",
    "SALES_MODULE_OFF": "Sales is turned off for your company, so no invoice can be issued.",
    "requestUsed": "That request was already used for another document: close this and start again.",
    "RECOVERY_ABOVE_ADVANCE": "The recovery would exceed the advance invoiced.",
    "RETENTION_ABOVE_GROSS": "Retention would exceed the gross certified.",
    "CERTIFICATE_DATE_ORDER": "That date is in the future or before the latest certificate: choose a date from the latest certificate to today.",
    "CLAIM_NOT_DRAFT": "The claim is no longer a draft: reload it.",
    "CLAIM_NOT_CERTIFIED": "Only a certified claim can be voided: reload it.",
    "CONTRACT_NOT_SETTLED": "The contract can’t close yet: a claim is open, retention is still held, the advance is not fully recovered or reduced, or a figure differs from the ledger.",
    "FORFEIT_EXCEEDS_HELD": "That is more than the retention still held.",
    "REDUCTION_EXCEEDS_OUTSTANDING": "That is more than the advance still outstanding.",
    "SIGNAL_NOT_ACTIVE": "This alert no longer applies, so there is nothing to acknowledge.",
    "GUARANTEE_CLOSED": "This guarantee is released or called, so it can no longer change.",
    "GUARANTEE_EVENT_ORDER": "Date the event on or after the guarantee’s issue date and its latest event, and not after today."
  },
  "salesOff": {
    "title": "Sales is turned off",
    "body": "No invoice can be issued or voided, so certifying, releasing retention and the advance wait until an administrator turns Sales on in Settings › Modules. Claims can still be measured and submitted."
  },
  "explain": {
    "client": "Client's figure: {{reason}}",
    "noRetention": "No retention on this contract",
    "cappedOriginal": "Capped at {{cap}}: {{pct}} of the original sum",
    "cappedCurrent": "Capped at {{cap}}: {{pct}} of the current contract value",
    "rate": "{{pct}} × {{gross}}",
    "noAdvance": "No advance to recover",
    "final": "Final certificate: recovers the remaining advance",
    "proRata": "Pro rata: advance {{advance}} × gross ÷ original sum {{original}}",
    "proRataCapped": "The whole advance ({{advance}}) is recovered",
    "fixed": "{{pct}} of the gross above {{threshold}}",
    "fixedNotYet": "Starts once the gross passes {{threshold}}",
    "manual": "Agreed figure (recovery by agreement)",
    "penalty": "Delay damages to date, as entered",
    "noPenalty": "No delay damages"
  },
  "forfeit": {
    "open": "Forfeit retention…",
    "title": "Forfeit retention",
    "body": "Retention the client keeps for good, for defects or a set-off. Projects posts it as a journal; void it here to reverse it.",
    "amount": "Amount forfeited",
    "amountHint": "At most {{balance}}, what is still held.",
    "date": "Date",
    "reason": "Reason",
    "reasonHint": "Why the client keeps it, with their letter’s reference.",
    "reasonRequired": "Give a reason.",
    "confirm": "Forfeit",
    "consequence": "Contract revenue and profit fall by {{amount}}. The client owes {{amount}} less, and {{after}} of retention stays held. Nothing is sent to the client.",
    "slip": "Journal: retention forfeited",
    "done": "{{amount}} of retention forfeited",
    "forfeited": "Forfeited",
    "listTitle": "Forfeits",
    "journalLink": "Journal",
    "voidNamed": "Void the forfeit of {{amount}}",
    "voidTitle": "Void this forfeit",
    "voidBody": "The journal is reversed and {{amount}} counts as held again.",
    "voidConfirm": "Void forfeit",
    "voided": "Forfeit voided",
    "consequenceEmpty": "Contract revenue and profit fall by the amount forfeited, and the client owes that much less. Nothing is sent to the client."
  },
  "reduce": {
    "open": "Reduce advance…",
    "title": "Reduce the advance",
    "body": "A credit note on the advance invoice, VAT at the advance’s rate. Projects issues it, so Sales can’t void it: void it here.",
    "when": "Use it when the client agrees to take back part of the advance, for example when the remaining advance is more than the final certificate’s gross.",
    "unblocksTitle": "This lets {{number}} pass",
    "unblocksBody": "The remaining advance is more than this certificate’s gross. Reducing the advance by {{amount}} lets the final certificate recover the rest without going negative.",
    "amount": "Reduce by (before VAT)",
    "amountHint": "At most {{outstanding}}, the advance still outstanding.",
    "date": "Date",
    "reason": "Reason",
    "reasonRequired": "Give a reason.",
    "confirm": "Issue credit note",
    "consequence": "A credit note of {{net}} + VAT ({{total}} in all) is issued to the client against advance invoice {{invoice}}.",
    "slip": "Credit note on {{invoice}}",
    "done": "Credit note for {{amount}} issued",
    "reduced": "Reduced",
    "listTitle": "Reductions",
    "withVat": "{{total}} with VAT",
    "voidNamed": "Void credit note {{number}}",
    "voidTitle": "Void credit note {{number}}",
    "voidBody": "The credit note of {{total}} is voided and the advance outstanding goes back up.",
    "voidConfirm": "Void credit note",
    "voided": "Reduction voided",
    "stuckTitle": "{{number}} waits for an advance reduction",
    "stuckBody": "The final certificate would be negative: reduce the advance by {{amount}} so it recovers the rest.",
    "consequenceEmpty": "A credit note for the amount you enter, plus VAT, is issued to the client against advance invoice {{invoice}}.",
    "effect": {
      "owes": "That invoice still has {{balance}} unpaid, so this lowers what the client owes by {{total}}.",
      "paid": "That invoice is paid, so the client is owed {{total}}: refund it or offset it against the next claim.",
      "part": "It clears the {{balance}} still unpaid on that invoice, and the client is owed the other {{rest}}: refund it or offset it against the next claim.",
      "unknown": "If that invoice is unpaid, this lowers what the client owes. If it is paid, the client is owed {{total}}: refund it or offset it against the next claim."
    },
    "effectEmpty": {
      "open": "That invoice still has {{balance}} unpaid: the credit note lowers what the client owes, up to that.",
      "paid": "That invoice is paid, so the client will be owed the credit note’s total: refund it or offset it against the next claim.",
      "unknown": "If that invoice is unpaid, this lowers what the client owes; if it is paid, the client is owed the credit note’s total: refund it or offset it against the next claim."
    }
  }
}
